import { render, staticRenderFns } from "./VuetifySurveyEditor.vue?vue&type=template&id=29bb0b88"
import script from "./VuetifySurveyEditor.vue?vue&type=script&lang=js"
export * from "./VuetifySurveyEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports